<div class="barplotRange">
  <div class="barplotRange__chart">
    <ng-container *ngFor="let bar of rateData.data; trackBy: trackByBarValue">
      <div
        class="chart__bar"
        [style.--bar-position.%]="bar.position"
        [class]="{ unselect: bar.value > rateData['checked'] }"
      ></div>
    </ng-container>
  </div>
  <div
    class="barplotRange__range"
    [style.--selected-range.%]="rateData['selectRangeProgress']"
  >
    <label for="rangeBar"
      ><span class="sr-only">Wertbereich auswählen</span>
      <input
        type="range"
        min="{{ rateData['amountMin'] }}"
        max="{{ rateData['amountMax'] }}"
        [(ngModel)]="rateData['checked']"
        [class.disabled]="rateData['disabled']"
        step=".01"
        #ranger
        id="rangeBar"
        (mouseup)="detectRange(ranger.value)"
        (touchend)="detectRange(ranger.value)"
      />
    </label>
  </div>
  <div class="barplotRange__range-amount">
    <p class="range-amount__disable" *ngIf="rateData['disabled']"></p>
    <p class="range-amount__disable" *ngIf="rateData['disabled']"></p>
    <p class="range-amount__first" *ngIf="!rateData['disabled']">
      <span
        >{{
          rateData["amountMin"].toLocaleString("de-DE", {
            minimumFractionDigits: 2
          })
        }}
      </span>
      &#8364;
    </p>
    <p class="range-amount__last" *ngIf="!rateData['disabled']">
      <span
        >{{
          rateData["amountMax"].toLocaleString("de-DE", {
            minimumFractionDigits: 2
          })
        }}
      </span>
      &#8364;
    </p>
  </div>
</div>
